module.exports = __webpack_public_path__ + "img/nishio-takumi@560w.51ff90d6.png";